import type { App } from 'vue'
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import {
  initializeFirestore,
  connectFirestoreEmulator
} from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

export const get_firebase_config = () => ({
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
  appId: import.meta.env.VITE_APP_ID
})

const firebase_app = getApps().length
  ? getApp()
  : initializeApp(get_firebase_config())

const auth = getAuth(firebase_app)
const db = initializeFirestore(firebase_app, {
  experimentalForceLongPolling: true,
  ignoreUndefinedProperties: true
})
const functions = getFunctions(firebase_app)
const storage = getStorage(firebase_app)

// Connect to emulators in development
if (import.meta.env.DEV) {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  // connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  // connectFirestoreEmulator(db, '127.0.0.1', 8080)
  // connectStorageEmulator(storage, '127.0.0.1', 9199)
}

auth.useDeviceLanguage()

export const get_firebase_instances = () => ({
  firebase_app,
  db,
  functions,
  storage,
  auth
})

export const install = (app: App) =>
  app.provide('firebase', get_firebase_instances())

export default install
